<template>
  <q-layout view="lHh Lpr lFf">
    <q-page-container>
      <Vega />
    </q-page-container>
  </q-layout>
</template>

<script>
import Vega from './views/Vega.vue'

export default {
  name: 'LayoutDefault',

  components: {
    Vega
  },
  setup () {
    return {

    }
  }
}
</script>
<style lang="scss" scoped>
body{
  overflow-y: hidden;
  overflow-x: hidden;
}
</style>
